module.exports = __webpack_public_path__ + "img/matic_icon.6bf3499b.png";